import { AwsRum, AwsRumConfig } from 'aws-rum-web';

import config from '../config';
import { runningOnProd } from '../Initialization';

let awsRum: AwsRum | null = null;

const initializeAwsRum = () => {
  if (!runningOnProd()) return;

  try {
    const rum = config.isGs1Flavor
      ? {
          appId: '6f58e6a0-d1f5-47cc-b187-84e155020003',
          identityPoolId: 'us-east-1:5e661796-321c-471e-a5e1-ac2ef289497d',
          guestRoleArn: 'arn:aws:iam::058160181968:role/RUM-Monitor-us-east-1-058160181968-5979442208071-Unauth',
        }
      : config.isLogycaFlavor
      ? {
          appId: '4aa87ac2-3d4a-4eaf-abf0-924ca4881966',
          identityPoolId: 'us-east-1:f1b9eeb7-f8b6-4ec3-9ac2-7d7bcb433f64',
          guestRoleArn: 'arn:aws:iam::903187542625:role/RUM-Monitor-us-east-1-903187542625-Platform-Unauth',
        }
      : {
          appId: 'fa5c88da-cadd-47fe-bd1c-408aa6bd2705',
          identityPoolId: 'us-east-1:e38d00fe-eebd-4156-bb78-ff41acdacdbc',
          guestRoleArn: 'arn:aws:iam::244227163619:role/RUM-Monitor-us-east-1-244227163619-4622622110861-Unauth',
        };

    const awsConfig: AwsRumConfig = {
      sessionSampleRate: 1,
      guestRoleArn: rum.guestRoleArn,
      identityPoolId: rum.identityPoolId,
      endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: false,
    };
    const APPLICATION_VERSION = '1.0.0';
    const APPLICATION_REGION = 'us-east-1';

    awsRum = new AwsRum(rum.appId, APPLICATION_VERSION, APPLICATION_REGION, awsConfig);
  } catch (error) {
    // TODO log me
  }
};

const addUserMetadata = ({
  clientName,
  email,
  userName,
  planNameFull,
}: {
  clientName?: string;
  email?: string;
  userName?: string;
  planNameFull?: string;
}) => {
  // Build attributes object
  const attributes: Record<string, string> = {};

  if (clientName) {
    const [name] = clientName.split('_');
    attributes.clientName = name;
  }
  if (email) {
    attributes.email = email;
  }
  if (userName) {
    attributes.userName = userName;
  }
  if (planNameFull) {
    attributes.planNameFull = planNameFull;
  }

  if (!runningOnProd()) {
    return;
  }

  try {
    if (Object.keys(attributes).length > 0) {
      awsRum?.addSessionAttributes(attributes);
    }
  } catch (error) {
    // Silent fail - RUM errors shouldn't affect user experience
  }
};

// TODO: send resource tag here
const sendCustomEvent = (eventName: string, eventAttributes: object = {}) => {
  if (!runningOnProd()) {
    return;
  }

  try {
    awsRum?.recordEvent(eventName, eventAttributes);
  } catch (error) {
    // pass
  }
};

const sendErrorEvent = (error: any) => {
  if (!runningOnProd()) {
    return;
  }

  try {
    awsRum?.recordError(error);
  } catch (_error) {
    // TODO log me
  }
};

export default initializeAwsRum;
export { addUserMetadata, sendCustomEvent, sendErrorEvent };
